import React, { useEffect, useRef, useState } from "react";
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";
import { useStateAuthValue } from "../../context/AuthState";
import { useNavigate } from "react-router-dom/dist";
import { set } from "date-fns";
import encode from "jwt-encode";
import { getAllReports } from "../../services/reportsService";
import { showToast, ToastType } from "../../utils/ToastUtil";
import { useToast } from "../../context/Toast/ToastProvider";

export const SpecialUserView = () => {
  const [{ userToken }] = useStateAuthValue();
  const navigate = useNavigate();
  useEffect(() => {
    if (!userToken) {
      navigate("/login");
    }
    return () => {};
  }, [userToken]);
  const [swaggerFile, setSwaggerFile] = useState("");
  const username = localStorage.getItem("username");
  let userType = username ? username.split("@")[1] : ""
  useEffect(() => {
    const swaggerMap = {
      "user@gallion": "/swagger_gallion.yaml",
      "user@sisargentina": "/swagger_sis.yaml",
      "user@social-gateway": "/swagger_social-gateway.yaml",
      "user@triunfo-ap": "/swagger_triunfo-ap.yaml",
    };
    setSwaggerFile(swaggerMap[username] || "");
    GetReports();
  }, []);
  const [url, setUrl] = useState("");
  const [reports, setReports] = useState([]);
  const embeber = (token, dashboard) => {
    const payload = {
      resource: { dashboard: dashboard },
      params: {
        canal: "TMOTOS",
      },
      exp: Math.round(Date.now() / 1000) + 120 /*minutos*/ * 60 /*segundos*/,
    };
    const tokenJWT = encode(payload, token);
    const url =
      process.env.REACT_APP_API_URL +
      `/embed/dashboard/${tokenJWT}#bordered=true&titled=true`;
    return url;
  };
  const toastDispatch = useToast();

  const displayError = (msg) =>
    showToast(toastDispatch, msg, ToastType.ERROR, ToastType.ERROR);
  const GetReports = async () => {
    let reportsGet = await getAllReports(userToken, displayError);
    let report = null;
    console.log(userType);
    
    if (userType == "ventas-asesora") {
      report = reportsGet?.find((element) => element.name === "Ventas por link");
    }
    if (report) {
      setUrl(embeber(report.secrey_key, parseInt(report.remote_id, 10)));
    }
    setReports(reportsGet);
  };
  const handleRender = () => {
    switch (userType) {
      case "gallion":
      case "sisargentina":
      case "social-gateway":
      case "triunfo-ap":
        return (
          <div>
            <SwaggerUI url={swaggerFile} />
          </div>
        );
      case "ventas-asesora":
        return (
          <div>
            <div className="report">
              {
                <iframe
                  src={url}
                  className="iframe-report"
                  frameBorder="0"
                  width="100%"
                  height="100%"
                  allowtransparency="true"
                ></iframe>
              }
            </div>
          </div>
        );
      default:
        return (
          <div>
            <h1>No hay vistas creadas</h1>
          </div>
        );
    }
  };
  return handleRender();
};
